
import { api } from "../api";

/**
 * secretaryUpdateStatusById - Function that updates on database an existing secretary status by id  
 * /secretaries/{id}/{status}  
 * method PUT  
 * @async-function
 */
const secretaryUpdateStatusById = async (token: string, id: number, status: string) => {
    const response = await api.put(
        `/secretaries/${id}/${status}`, {}, {
             headers: { 'Authorization': `Bearer ${token}` }
        });
    return response;
};
export default secretaryUpdateStatusById;
